import styles from '../index.module.css';
import { ReactComponent as GenericProvider } from 'common/dist/assets/user.svg';
import React, { useEffect, useRef } from 'react';
import { ProviderOptionData } from '../data';
import HighlightedProviderName from '../HighlightedProviderName';
import { getProviderNameFriendly } from '../../../../../utils/provider';

interface ProviderOptionProps extends ProviderOptionData {
  input: string;
  onClicked: () => void;
  isSelected: boolean;
}

const ProviderOption: React.FC<ProviderOptionProps> = (props) => {
  const onClickHandler = (event: React.MouseEvent<HTMLInputElement>) => {
    props.onClicked();
  };
  const { input, specialty, location, isSelected } = props;

  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isSelected && scrollRef && scrollRef.current) {
      scrollRef.current.scrollIntoView({
        block: 'end',
        inline: 'nearest',
      });
    }
  });

  return (
    <div
      className={styles.ProviderOption}
      onClick={onClickHandler}
      ref={scrollRef}
      style={isSelected ? { backgroundColor: 'var(--color-shade-30)' } : {}}
    >
      <div className={styles.Border} />
      <div className={styles.ProviderPictureWrapper}>
        <GenericProvider
          viewBox="0 0 24 24"
          className={styles.ProviderPicture}
        />
      </div>
      <div className={styles.ProviderInfo}>
        <HighlightedProviderName
          name={getProviderNameFriendly(
            {
              firstName: props.firstName,
              lastName: props.lastName,
              prefix: props.prefix ?? null,
              suffix: props.suffix ?? null,
            },
            ['firstName', 'lastName', 'prefix', 'suffix'],
          )}
          substring={input}
        />
        <div className={styles.ProviderDetails}>
          {specialty}. {location}
        </div>
      </div>
    </div>
  );
};

export default ProviderOption;
